import { cards } from '@/mocks/homeData';

export default function Cards() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新黑料爆料
            </h2>
            <p className="text-sm text-foreground-500 font-body">每日更新，全网最快网红塌房翻车一手资讯</p>
          </div>
          <a
            href="#updates"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer no-underline"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {cards.slice(0, 7).map((card, i) => (
            <article
              key={i}
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    if (target.parentElement) {
                      target.parentElement.style.display = 'none';
                    }
                  }}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-md font-label">
                  {card.category}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-4 md:p-5 gap-3">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 leading-snug line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-500 font-body leading-relaxed line-clamp-3">
                  {card.excerpt}
                </p>
                <div className="flex flex-wrap items-center gap-2 mt-auto pt-2">
                  {card.tags.map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-full font-label"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="flex items-center justify-between pt-2 border-t border-background-100">
                  <span className="text-xs text-foreground-400 font-label">{card.date}</span>
                  <span className="inline-flex items-center gap-1 text-xs text-foreground-600 font-medium whitespace-nowrap cursor-pointer">
                    阅读全文 <i className="ri-arrow-right-s-line text-sm"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}